var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"6"}},[_c('HiveStatus')],1),_c('v-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"6"}},[_c('QueenAge')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }